export { WhatsAppIcon } from "./social-whatsapp";
